import React from 'react';
import {getItemPrice} from "../helpers/common";
import FormattedPrice from "./FormattedPrice";

const SupplementsList = ({supplementsList, selectedSupplements, onSelect}) => {
  const isSelected = (item) => {
    return selectedSupplements.some( i => i.menuItem.menu_item_id === item.menu_item_id);
  };
  return (
    <div className={'supplements-list'}>
      {
        supplementsList.map(item => (
          <div className={`supplement ${isSelected(item) ? 'selected' : ''}`} onClick={ ()=> { onSelect(item) }}>
            { item.item_name }
            { item.web_price > 0 && (
              <div className={'item-price'}>
                <FormattedPrice price={ item.web_price  } />
              </div>
            )}
          </div>
        ))
      }
    </div>
  );
};

export default SupplementsList;
